import { BehaviorSubject } from 'rxjs';

export class CheckboxListModel {
    DataSet = [];
    DataNameField = '';
    DataIdField = '';
    DataChildItemField = 'ChildItems';
    HeaderName = '';
    ShowHeader = false;
    IsEnabled = true;
    CheckedItems = [];
    AllowMultiSelect = true;

    IsHeaderCheckboxHidden = true;

    onIsHeaderEnabledChange: BehaviorSubject<boolean>;

    constructor(data?) {
        if (data) Object.assign(this, data);

        this.onIsHeaderEnabledChange = new BehaviorSubject<boolean>(this.AllowMultiSelect);
    }

    setIsHeaderEnabled(newIsHeaderEnabled: boolean) {
        this.onIsHeaderEnabledChange.next(newIsHeaderEnabled && this.AllowMultiSelect);
    }

    //Need to call a sub-function for recursive call.
    CheckItems(ids) {
        const self = this;

        this.DataSet.forEach((item) => CheckItems(ids, item));

        function CheckItems(ids, item) {
            item[self.DataChildItemField].forEach((item) => CheckItems(ids, item));
            const allChildrenChecked =
                item[self.DataChildItemField] && item[self.DataChildItemField].length
                    ? item[self.DataChildItemField].every((childItem) => childItem.Checked)
                    : false;

            item.Checked = ids.indexOf(item.Id) !== -1 || allChildrenChecked;
        }
    }
}
